import React from 'react';

const Header = () => (
  <div className="header-section">
    <img className="header-logo" src="/images/lilicats-logo.svg" alt="Lilicats Logo" />
  </div>
);

export default Header;
